/* eslint-disable */
/* eslint-disable camelcase */
import * as React from 'react';
import { useForm } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { IconButton, InputAdornment, Stack, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import swal from 'sweetalert';
import { dropDownSubLesson, getTrainingLessonDataForUpdate, trainingLessonUpdate } from '../../../common/api-service';

function EditTrainingLesson() {
  const navigate = useNavigate();
  const theme = useTheme();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const lesson_status = ['active', 'disabled'];

  function getStyles(pet_type, petName, theme) {
    return {
      fontWeight:
        petName.indexOf(pet_type) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
    };
  }

  const [AdminNotes, setAdminNotes] = useState('');
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState('');
  const [subLesson, setSubLesson] = useState([]);
  const [lessonStatus, setLessonStatus] = React.useState('');
  const [lessonfieldCount, setLessonFieldCount] = useState([]);
  const [serviceMasterId, setServiceMaster] = React.useState('62f646cde874f755ae088610');
  const [idget, setIdget] = React.useState('');
  const [dropDownData, setDropDownData] = useState([]);

  const getLessonID = () => {
    const getLessonID = localStorage.getItem('getLessonID');
    setIdget(getLessonID);
    const payload = {
      _id: getLessonID,
    };

    return getTrainingLessonDataForUpdate(payload).then((res) => {
      if (res.data.status === true) {
        const data = res.data.data;
        setUserName(data.title);
        const sublesson_title = data.sub_lessons;
        const sublesson_title1 = sublesson_title.map((e) => {
          e = e.title;
          return e;
        });
        setLessonFieldCount(sublesson_title1);
        setAdminNotes(data.admin_notes);
        const subLessonTitle = data.sub_lessons;
        const subLessonTitle1 = subLessonTitle.map((e) => {
          e = e.title;
          return e;
        });
        setSubLesson(subLessonTitle1);
        setServiceMaster(data.service_master_id);
        setLessonStatus(data.status);
      } else {
        console.log('error');
      }
    });
  };

  const subLessonTitle = (payload) => {
    return dropDownSubLesson(payload).then(
      (res) => {
        setDropDownData(res.data.data);
      },
      (err) => {
        console.log('err data: ', err);
      }
    );
  };

  useEffect(() => {
    subLessonTitle();
    getLessonID();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: 'all',
  });

  const onSubmit = () => {
    var subTitle = dropDownData.filter(function (obj) {
      return subLesson.indexOf(obj.title) !== -1;
    });

    setLoading(true);
    const payload = {
      _id: idget,
      title: userName,
      sub_lessons: subTitle,
      admin_notes: AdminNotes,
      status: lessonStatus,
    };
    return trainingLessonUpdate(payload).then(
      (res) => {
        if (res.data.status === true) {
          setLoading(false);

          swal({
            title: res.data.message,
            icon: 'success',
            timer: 2000,
            button: false,
          });
          navigate('/dashboard/lesson', { replace: true });
          localStorage.removeItem('getLessonID');
        } else {
          swal({
            title: res.data.message,
            icon: 'success',
            timer: 2000,
            button: false,
          });
        }
      },
      (err) => {
        console.log('err', err);
      }
    );
  };

  return (
    <div>
      <Typography
        variant="h3"
        component="div"
        sx={{
          '& > :not(style)': { width: '25ch' },
        }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        Update Lesson
      </Typography>
      <Card>
        <CardContent>
          <Box component="form" minHeight="50vh" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
              <Grid container>
                <Grid item xs={12} sm={12}>
                  <Grid>
                    {/* Title */}
                    <TextField
                      id="outlined-basic"
                      label="Title"
                      variant="outlined"
                      value={userName}
                      name="title"
                      required
                      {...register('title', {
                        required: true,
                      })}
                      onChange={(e) => setUserName(e.target.value)}
                      style={{ width: '100%' }}
                    />
                    {errors.title && errors.title.type === 'required' && (
                      <p className="text-danger" style={{ color: 'red' }}>
                        *required
                      </p>
                    )}
                  </Grid>

                  {/* Sub Titles */}
                  <Grid>
                    <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                      <InputLabel id="demo-multiple-chip-label">Sub Lesson</InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        multiple
                        value={subLesson}
                        onChange={(e) => {
                          setSubLesson(e.target.value);
                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Sub Lesson" />}
                        MenuProps={MenuProps}
                      >
                        {dropDownData.map((e) => (
                          <MenuItem key={e._id} value={e.title} style={getStyles(e, subLesson, theme)}>
                            {e.title}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Admin Notes */}
                  <Grid sx={{ mt: 3 }}>
                    <TextField
                      id="outlined-basic"
                      label="Admin Notes"
                      variant="outlined"
                      value={AdminNotes}
                      onChange={(e) => setAdminNotes(e.target.value)}
                      style={{ width: '100%' }}
                    />
                  </Grid>

                  {/* Status */}
                  <Grid>
                    <FormControl sx={{ minWidth: '100%', mt: 3 }}>
                      <InputLabel id="demo-multiple-chip-label">Status</InputLabel>
                      <Select
                        labelId="demo-multiple-chip-label"
                        id="demo-multiple-chip"
                        // multiple
                        value={lessonStatus}
                        onChange={(e) => {
                          setLessonStatus(e.target.value);
                        }}
                        input={<OutlinedInput id="select-multiple-chip" label="Status" />}
                        MenuProps={MenuProps}
                      >
                        {lesson_status.map((lesson_status) => (
                          <MenuItem
                            key={lesson_status}
                            value={lesson_status}
                            style={getStyles(lesson_status, lessonStatus, theme)}
                          >
                            {lesson_status}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid sx={{ mt: 3 }}>
                    <Box component="span" m={1} display="flex" justifyContent="space-between" alignItems="center">
                      <LoadingButton variant="contained" type="submit">
                        Update Lesson
                      </LoadingButton>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}

export default EditTrainingLesson;
